import { createSelector } from 'reselect';

//input selectors
const selectSalaryRanges = saveJobPricing => saveJobPricing.salaryRanges;
const selectSalaryRange = saveJobPricing => saveJobPricing.salaryRange;

//output selectors
export const selectStructures = createSelector([selectSalaryRanges], salaryRanges => {
  const reference = new Map();
  const structures = [];
  salaryRanges.forEach(range => {
    let structure = reference.get(range.value);
    if (structure) return structure.ranges.push(range);

    structure = createStructureFromRange(range);
    reference.set(range.value, structure);
    structures.push(structure);
  });

  return structures;
});

export const selectJobStructure = createSelector([selectSalaryRange, selectStructures], (salaryRange, structures) => {
  if (salaryRange && !structures.length) return createStructureFromRange(salaryRange);
  if (salaryRange && structures.length) {
    const jobStructure = structures.find(structure => structure.value === salaryRange.value);
    if (!jobStructure) return createStructureFromRange(salaryRange);
    return jobStructure;
  }
  return null;
});

const createStructureFromRange = range => ({
  value: range.value,
  label: range.label,
  currency: range.currency,
  ranges: [range]
});
